import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<
  void,
  'inputRoot' | 'disabled' | 'checked'
>()(({ breakpoints, tokens, px }, _, classes) => ({
  root: {
    gap: tokens.spacing['8'],
    marginBottom: tokens.spacing['24'],

    [breakpoints.up('md')]: {
      gap: tokens.spacing['24'],
    },
  },

  withoutMargins: {
    margin: 0,
  },

  itemRoot: {
    alignItems: 'flex-start',
    margin: 0,

    [`& .${classes.inputRoot} .MuiIconButton-label`]: {
      position: 'relative',

      '&::after': {
        position: 'absolute',
        top: tokens.spacing['4'],
        left: tokens.spacing['4'],
        display: 'block',
        width: px(16),
        height: px(16),
        backgroundColor: tokens.colors.bg.light.primary,
        borderRadius: '50%',
        content: "''",
      },
    },

    '& .MuiSvgIcon-root': {
      zIndex: 1,
    },

    [`&:hover:not(.${classes.disabled})`]: {
      '& .MuiSvgIcon-root path': {
        fill: tokens.colors.original.brand.primary,
      },

      [`& .${classes.checked} .MuiSvgIcon-root path`]: {
        fill: tokens.colors.original.brand.tertirary,
      },
    },

    [`&:not(.${classes.disabled}) .${classes.inputRoot}.${classes.checked} .MuiSvgIcon-root path`]:
      {
        fill: tokens.colors.original.brand.primary,
      },

    [`&.${classes.disabled} .${classes.inputRoot} .MuiIconButton-label::after`]:
      {
        top: tokens.spacing['2'],
        left: tokens.spacing['2'],
        width: px(20),
        height: px(20),
        backgroundColor: tokens.colors.bg.greyscale.primary,
      },

    [`&.${classes.disabled} .${classes.inputRoot}.${classes.checked} .MuiIconButton-label .MuiSvgIcon-root`]:
      {
        '&:first-of-type path': {
          fill: 'transparent',
        },

        '&:last-of-type path': {
          fill: tokens.colors.stroke.secondary,
        },
      },
  },

  inputRoot: {
    paddingTop: 0,
    paddingRight: tokens.spacing['2'],
    paddingBottom: 0,
    paddingLeft: tokens.spacing['2'],

    [`&:hover, &:hover.${classes.checked}`]: {
      backgroundColor: 'transparent',
    },

    '& .MuiSvgIcon-root path': {
      fill: tokens.colors.stroke.primary,
    },
  },

  label: {
    marginTop: tokens.spacing['2'],
  },

  checked: {},

  disabled: {},
}));
